/**
 * Rupee ↔ paise conversion for merchant forms. Money is stored as integer
 * paise everywhere; forms take rupees. Parsing is string-based so 289.99
 * never becomes 28998 through float rounding.
 */

/** "₹28,999.50" | 28999.5 → 2899950. Returns null for blank/invalid/negative input. */
export function rupeesToPaise(input) {
  if (input == null) return null;
  const s = String(input).replace(/[₹,\s]/g, '').replace(/^rs\.?/i, '');
  if (s === '' || !/^\d+(\.\d{1,2})?$/.test(s)) return null;
  const [whole, frac = ''] = s.split('.');
  return Number(whole) * 100 + Number(frac.padEnd(2, '0'));
}

/** 2899950 → "28999.50"; 2899900 → "28999". Blank for null. */
export function paiseToRupees(paise) {
  if (paise == null || paise === '') return '';
  const n = Math.round(Number(paise));
  if (!Number.isFinite(n)) return '';
  const whole = Math.trunc(n / 100);
  const frac = Math.abs(n % 100);
  return frac ? `${whole}.${String(frac).padStart(2, '0')}` : String(whole);
}

/** Short Indian-style amount for chart labels: ₹4.2L, ₹85k, ₹1.1Cr. */
export function compactINR(paise) {
  const r = Number(paise || 0) / 100;
  if (r >= 1e7) return `₹${(r / 1e7).toFixed(1).replace(/\.0$/, '')}Cr`;
  if (r >= 1e5) return `₹${(r / 1e5).toFixed(1).replace(/\.0$/, '')}L`;
  if (r >= 1e3) return `₹${Math.round(r / 1e3)}k`;
  return `₹${Math.round(r)}`;
}

/** Whole-percent discount of price against MRP (0 when there is no valid MRP). */
export function discountPct(pricePaise, mrpPaise) {
  if (!mrpPaise || !pricePaise || mrpPaise <= pricePaise) return 0;
  return Math.round(((mrpPaise - pricePaise) / mrpPaise) * 100);
}
